/**
 * EL INICIO DE MADERINCO, "LA MESA DEL DIA" (MAD-DASHBOARD-ESTILO-T1, maqueta TcHr3kVzm4NjnEwMQXtPDt propuesta A, SI de
 * Josse #44147).
 *
 * Lo que necesita el dueno al entrar: crear un presupuesto o seguir el ultimo borrador, sus borradores y emitidos, y lo
 * que le falta al asistente para armar bien (precios por confirmar e items sin linea). Solo para el negocio de Maderinco:
 * los demas negocios y la tablet de colaboradores siguen como estan. Sin nombres de cliente: codigo, version, fecha y
 * total. Sin DOM: lo prueba scripts/check-inicio-maderinco.mjs.
 *
 * @module application/presupuestos/inicioMaderinco
 */

export const NEGOCIO_MADERINCO = 'biz_demo_maderinco';

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());
const numero = (v) => { const n = Number(v); return v === null || v === undefined || v === '' || !Number.isFinite(n) ? null : n; };
const de = (o, ...claves) => { for (const k of claves) if (o && o[k] !== undefined && o[k] !== null) return o[k]; return undefined; };

/** El inicio nuevo es para el negocio de Maderinco y no para los colaboradores (rol client: su tablet sigue igual). */
export function esInicioDeMaderinco(negocio, rol) {
  return texto(negocio) === NEGOCIO_MADERINCO && texto(rol).toLowerCase() !== 'client';
}

/** Un presupuesto de la lista (GET /api/v1/presupuestos) sin datos del cliente: id, codigo con version, estado, fecha y total. */
export function presupuestoDeLista(p) {
  const version = numero(de(p, 'version', 'Version'));
  const codigo = texto(de(p, 'codigo', 'Codigo')) || 's/c';
  return {
    id: texto(de(p, 'id', 'Id')),
    codigo: version && version > 1 ? `${codigo} v${version}` : codigo,
    estado: texto(de(p, 'estado', 'Estado')).toLowerCase() || 'borrador',
    fecha: texto(de(p, 'fecha', 'Fecha')).slice(0, 10),
    total: numero(de(p, 'total', 'Total'))
  };
}

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
/** '2026-08-27' -> '27 ago' (del mismo anio que hoy) o '27 ago 2025'. */
export function fechaCorta(iso, hoy = new Date()) {
  const m = texto(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';
  const dia = `${Number(m[3])} ${MESES[Number(m[2]) - 1]}`;
  return Number(m[1]) === hoy.getFullYear() ? dia : `${dia} ${m[1]}`;
}

/** El saludo por la hora (Bogota la pone el navegador del dueno). */
export function saludoDe(hora) {
  const h = Number(hora);
  return h < 12 ? 'Buenos días' : h < 19 ? 'Buenas tardes' : 'Buenas noches';
}

/**
 * La mesa del dia: borradores y emitidos (los mas recientes primero), el borrador con el que sigue, las sumas y lo que
 * falta. presupuestos = filas crudas de la API; cuentas = { porConfirmar, porClasificar } de la lectura del item estandar.
 */
export function mesaDelDia(presupuestos, cuentas = {}) {
  const lista = (Array.isArray(presupuestos) ? presupuestos : []).map(presupuestoDeLista)
    .sort((a, b) => (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0));
  const borradores = lista.filter((p) => p.estado === 'borrador');
  const emitidos = lista.filter((p) => p.estado !== 'borrador');
  const suma = (l) => l.reduce((a, p) => a + (p.total || 0), 0);
  return {
    borradores, emitidos,
    sigue: borradores[0] || null,
    sumaBorradores: suma(borradores), sumaEmitidos: suma(emitidos),
    porConfirmar: numero(cuentas.porConfirmar) ?? 0,
    sinLinea: numero(cuentas.porClasificar) ?? 0
  };
}
